module.exports = __webpack_public_path__ + "img/b380dfe438fbcab48c19f04e31c71bc5.png";